import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const fundingAppropriation = {
  state: {
    fundingAppropriations: [],
    selectedFundingAppropriation: {},
    selectedFundingAppropriationOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    fundingAppropriations(state) {
      return state.fundingAppropriations
    },
    selectedFundingAppropriation(state) {
      return state.selectedFundingAppropriation
    },
    selectedFundingAppropriationOriginal(state) {
      return state.selectedFundingAppropriationOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    fundingAppropriations(state, payload) {
      state.fundingAppropriations = payload
    },
    selectedFundingAppropriation(state, payload) {
      state.selectedFundingAppropriation = JSON.parse(JSON.stringify(payload))
    },
    selectedFundingAppropriationOriginal(state, payload) {
      state.selectedFundingAppropriationOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedFundingAppropriation(context, payload) {
      context.commit('selectedFundingAppropriation', payload)
    },
    async loadFundingAppropriations(context, payload) {
      const url = 'FundingAppropriation'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('fundingAppropriations', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async refreshSelectedFundingAppropriation(context, payload) {
      if (
        context.state.selectedFundingAppropriation &&
        context.state.selectedFundingAppropriation.Id > 0
      ) {
        return await context.dispatch(
          'loadSelectedFundingAppropriation',
          context.state.selectedFundingAppropriation.Id
        )
      }
    },
    async loadSelectedFundingAppropriation(context, payload) {
      if (
        context.state.selectedFundingAppropriation &&
        context.state.selectedFundingAppropriation.Id != payload
      ) {
        context.commit('selectedFundingAppropriation', {})
      }
      const url = 'FundingAppropriation/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedFundingAppropriation', res.data)
        context.commit('selectedFundingAppropriationOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async clearLookupCacheAndReloadFundingAppropriations(context, payload) {
      await caches.delete('apilookup-cache')
      return await context.dispatch('loadFundingAppropriations')
    },
    async createFundingAppropriation(context, payload) {
      const url = `FundingAppropriation`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding appropriation created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadFundingAppropriations')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchFundingAppropriation(context, payload) {
      var item = context.state.selectedFundingAppropriation
      if (
        payload.Id &&
        payload.Id == context.state.selectedFundingAppropriationOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedFundingAppropriationOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `FundingAppropriation/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'funding appropriation updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadFundingAppropriations')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateFundingAppropriation(context, payload) {
      const url = `FundingAppropriation/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding appropriation updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadFundingAppropriations')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveFundingAppropriation(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateFundingAppropriation', payload)
      } else {
        return context.dispatch('createFundingAppropriation', payload)
      }
    },
    async deleteFundingAppropriation(context, payload) {
      const url = `FundingAppropriation/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding appropriation deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadFundingAppropriations')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default fundingAppropriation
